module.exports = __webpack_public_path__ + "img/quality.40cc2462.png";